import React, { Component } from 'react';
import $ from 'jquery';

//import Partnerlayout from './Partnerlayout';
import AdminLayout from './layout';

import loadinggif from '../../../src/assets/bewiseloading.gif';

import {
  getLeadsByPartner,
  getVendorInfo,
  approveVendorInfo,
  approveVendorInfoCurated,
  rejectVendorInfo,
  commonAPI, adminUser,
  indResponse,
  getPayLink,
  userExport,
  sendMailPayLink,
  partnerSubscription,
  getPlan,
  getDiscountNew,
  savePayLink,
  creatediscount,
  checkDiscountInfo
} from "../../API/FetchCall";
 
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

class partnerDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
        logged: localStorage.getItem("authentication"),
        auth_data: JSON.parse(localStorage.getItem("user_data")),
        vendor_id: this.props.match.params.id,
        category_id: "",
        errors: [],
        reject_reason: "",
        generated_by:"",
        data: [],
        keyinfo: [],
        photos_arr: [],
        stamp_list: [],
        package_list: [],
        planlist:[],
        period:0,
        stamp_id: 0,
        nstamp_id: 0,
        generated:false,
        loading:false,
        showprice:false,
        short_url:'',
        discount:0,
        email_id:'',
        nplan_id:'',
        write_permission: true,
        opener:false,
        leads: [{ name: "", 
        enddate : "",
        fromdate : "",
        starttime : "",
        feeinr : "",
        feeusd : "",
        duration : "",
        days : "" }],
        };
    this.getStampList();
    this.generatePayLink = this.generatePayLink.bind(this);
    this.getPlanList();
    
    this.openDiscountBlock = this.openDiscountBlock.bind(this);
    this.getCurrentPlanList = this.getCurrentPlanList.bind(this);
    this.handlePaymentLink = this.handlePaymentLink.bind(this);
    this.showprice = this.showprice.bind(this);
    this.updatePrice = this.updatePrice.bind(this);
    this.getPlanList = this.getPlanList.bind(this);

    }

    async leadList(partnerId) {

        let insdata = JSON.stringify({
              login_id:this.state.login_id
        });
    getLeadsByPartner(insdata).then((response) => {

        if (response.status === 1) {

            const newLeads = response.leads.map((lead) => ({
                "id": lead.id,
                "firstname": lead.firstname,
                "lastname": lead.lastname,
                "vertical": lead.lead_vertical,
                "searchkey": lead.searchkey,
                "location": lead.location,
                "mobilenumber": lead.mobilenumber,
                "status":lead.lead_status,
                "email": lead.email,
                "createdAt": new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(lead.created_date)
            }));

            this.setState({ leads: newLeads});

        }

      });  

    }

     getCurrentPlanList = () => {
    let insdata = JSON.stringify({
      user_type: 1,
      partner_id: this.state.login_id,
      role: 3,
      url: 'getPartnerPlanV1'
    });
    partnerSubscription(insdata).then((response) => {
      if (response.status === 1) {
        console.log("RR", response);
        this.setState({
          package_list: response.plan_list,
          upgradeList: response.upgrade_list,
          cgst_per: response.tax_data.cgst,
          sgst_per: response.tax_data.sgst,
          coupon_id: response.coupon_data.coupon_id,
          coupon_per_or: response.coupon_data.coupon_per,
          coupon_amount_or: response.coupon_data.coupon_amount,
          partner_name: response.partner.name, partner_email: response.partner.email, partner_address: response.partner.address
        })
      }
    })
  }
  getPlanList() {
    let planData = JSON.stringify({
      user_type: 1,
    });
    getPlan(planData).then((response) => {
      if (response.status == 1) {
        this.setState({
          planlist: response.results,
        });
      }
    });
  }  

  openDiscountBlock(){

     let ins = JSON.stringify({
          vendor_id:this.state.vendor_id
      });

      checkDiscountInfo(ins).then((res)=>{
         if (res.status == 1) {

              if(res.result.length>0){
                  //open modal
                   
                  var data =res.result[0];
                  this.setState({id:data.id, vendor_id:data.vendor_id, discount:data.discount});
                  
              }else{
                  this.setState({id:0, discount:5});
              }

              window.$("#discount-modal").modal("show");

         }
         else{

          NotificationManager.error('Issue');


         }
      });
  }

  componentDidMount() {
    let userinfo = JSON.stringify({
      vendor_id: this.state.vendor_id,
    });

    let user_data = localStorage.getItem("user_data");
    let auth_data = JSON.parse(user_data);
    let generated_by = auth_data.login_id;
    this.setState({generated_by:generated_by});

    const { role } = this.state.auth_data;
    let req = JSON.stringify({
      url: "getVendorInformation",
      role: role,
      path: '/vendorlist',
      vendor_id: this.state.vendor_id,
    });
    commonAPI(req).then((res) => {
      if (res.status === 1) {
        let stamp_id = res.results ? res.results.stamp_id : 0;
        this.setState({
          write_permission: true,
          data: res.results,
          stamp_id: stamp_id,
          nstamp_id: stamp_id == 0 ? 3 : 0,
          keyinfo: (res.results.extra)?res.results.extra:[],
          photos_arr: res.results.photo_arr,
        });
      }
    });
    getVendorInfo(userinfo).then((response) => {
      if (response.status == 1) {
        let data = response.results[0];
        this.setState({
          user_type: data.user_type == 1 ? "Institutional" : "Individual",
          user_paytype: data.user_paytype == 1 ? "Paid" : "Free",
          vendor_id: data.vendor_id,
          set_id: data.set_id,
          login_id: data.login_id,
          reg_process: data.reg_process,
          partner_name: data.first_name + " " + data.last_name,
          email_id: data.email_id,
          user_name: data.user_name,
          organisation_name: data.organisation_name,
          organisation_register_number: data.organisation_register_number,
          institution_email_address: data.institution_email_address,
          phone_number: data.phone_number,
          institution_contact_number: data.institution_contact_number,
          state: data.state,
          location: data.location,
          pin_code: data.pin_code,
          address: data.address,
          status: data.status,
          created_date: data.created_date,
          usertype: data.user_type,
          plan_name: data.plan_name,
          category_id: data.category_id ? data.category_id.split(",") : [],
          plan_category_id: data.plan_category_id,
          plan_month: data.plan_month,
          about_words_count: data.about_words_count,
          image_count: data.image_count,
          registration_no: data.registration_no,
          organization_name: data.organization_name,
          owner_name: data.owner_name,
          school_board_of_education: data.school_board_of_education,
          school_sub_types: data.school_sub_types,
          school_sub_type: data.school_sub_type,
          preschool_schoolType: data.preschool_schoolType,
          playarea_age_group: data.playarea_age_group,
          playarea_sub_type: data.playarea_sub_type,
          hobbies_cate: data.hobbies_cate,
          hobbies_subcatgory: data.hobbies_subcatgory,
          hobbies_sub_type: data.hobbies_sub_type,
          tutions_cate: data.tutions_cate,
          languages: data.languages,
          tutor_name: data.tutor_name,
          event_type: data.event_type,
          invities: data.invities,
          camp_sub_type: data.camp_sub_type,
          commmunity_type: data.commmunity_type,
          service: data.service,
          designation: data.designation,
          email_id_info: data.email_id_info,
          phone_number_info: data.phone_number_info,
          landline_number_info: data.landline_number_info,
          address_info: data.address_info,
          location_name: data.location_name,
          area: data.area,
          state_name: data.state_name,
          country: data.country,
          pincode: data.pincode,
          google_location: data.google_location,
          website: data.website,
          about: data.about,
          key_words: data.key_words,
          category: data.category,
          admission_link: data.admission_link,
          admission_process: data.admission_process,
          application_fees: data.application_fees,
          required_documents: data.required_documents,
          school_type: data.school_type,
          classification: data.classification,
          grade_to: data.grade_to,
          grade: data.grade,
          from_time: data.from_time,
          from_time_cate: data.from_time_cate,
          to_time: data.to_time,
          to_time_cate: data.to_time_cate,
          min_age: data.min_age,
          instruction_lang: data.instruction_lang,
          student_ratio: data.student_ratio,
          establishment_year: data.establishment_year,
          amenities: data.amenities,
          average_fees: data.average_fees,
          class_fee: data.class_fee,
          class_fee_type: data.class_fee_type,
          other_fees: data.other_fees,
          admission_fees: data.admission_fees,
          isrefund: data.isrefund == 1 ? "Yes" : "No",
          board_of_education: data.board_of_education,
          no_of_teachers: data.no_of_teachers,
          // photos_arr: data.photo_arr,
          url: data.url,
          images: data.images,
          entry_fees: data.entry_fees,
          std_ratio: data.std_ratio,
          tution_type: data.tution_type,
          age_group: data.age_group,
          class_frequency: data.class_frequency,
          class_range: data.class_range,
          area: data.area,
          facebook: data.facebook,
          twitter: data.twitter,
          payment_name: data.mode_of_payment,
          apporve_status: data.status == 1 ? "Approved" : "Pending or Waiting for Approval",
          reject_reason: data.reject_reason,
          amount: data.amount,
          discount: data.discount,
          discount_amount: data.discount_amount,
          plan_price_original: data.plan_price_original,
          id_proof: data.id_proof,
          id_proof_no: data.id_proof_no,
          qualification: data.qualification,
          othercomments: data.othercomments,
          plan_id: data.plan_id,
          reg_status:data.reg_status
        });

        this.getCurrentPlanList(); 

        this.leadList(this.props.match.params.id);

      } else {
        console.log(response.status);
      }
    });
  }
  componentDidUpdate() {
    
  }

  updatePrice = (e) => {

          const propName = e.target.name;
          this.setState({ [e.target.name]: e.target.value });

          let optbannerprice = e.target.value;
          let sub_total = this.state.sub_total;
          console.log(optbannerprice);
          console.log(sub_total);
          let total = (sub_total+parseFloat(optbannerprice));
          this.setState({
              total:total
          })

  }

  showprice = (e) =>{

        let value = e.target.value;
        //console.log(value);
        //var value = this.state.nplan_id;
        console.log(value);
        console.log(this.state.planlist[value]);
        var data = this.state.planlist;
        var plan_name = data[value].plan_name;
        var plan_id = data[value].id;
        var period = this.state.period;

        if (period == 183) {
        // base_price = parseFloat(temp) > 0 ? parseFloat(data[0].base_price) + 1 : parseFloat(data[0].base_price);
        var plan_price = data[value].price_six;
        var sub_total = data[value].price_six;
        var total = data[value].price_six;

        }else{
          var plan_price = data[value].base_price;
          var sub_total = data[value].base_price;
          var total = data[value].base_price;
        }

        //var plan_price = data[value].base_price;
        //var sub_total = data[value].base_price;
        //var total = data[value].base_price;
        var discount = data[value].discount_amount;
        

        let req = JSON.stringify({
          vendor_id: this.state.vendor_id
        });

        getDiscountNew(req).then((res) => {

          console.log(res);

          if (res.status === 1) {
            var discnt = parseInt(res.data[0].discount);

          }else{
            var discnt = 0;
          }  

        
          if(discnt>0){
              
              discount = plan_price * (discnt/100);
              total = (plan_price) - (discount);

          }

          if(this.state.optbanners=='yes'){
            var costofbanners = parseInt(this.state.optbannerprice);
            total = (total) + (costofbanners);
          }

          this.setState({
              showprice: true,
              discount_amount:discount,
              discount_per:discnt,
              discount:discount,
              plan_name:plan_name,
              plan_id:plan_id,
              plan_price:plan_price,
              sub_total:sub_total,
              total:total
          })
          
        })
    
  }

  getStampList = () => {
    let req = JSON.stringify({
      url: 'getStampList',
    });
    adminUser(req).then((res) => {
      if (res.status === 1) {
        this.setState({
          stamp_list: res.list
        })
      }
    })
  }
  showValidationErr(elm, msg) {
    this.setState((prevState) => ({
      errors: [...prevState.errors, { elm, msg }],
    }));
  }
  clearValidationErr(elm) {
    this.setState((prevState) => {
      let newArr = [];
      for (let err of this.state.errors) {
        if (elm !== err.elm) {
          newArr.push(err);
        }
      }
      return { errors: newArr };
    });
  }

  importSchool = () => {
    window.$("#import-modal").modal("show");
  };

  handleChange = (e) => {
    const propName = e.target.name;
    this.setState({ [e.target.name]: e.target.value });
    if(propName=='optbanners' && e.target.value=='no'){
      this.setState({opener:false});
    }else{
      this.setState({opener:true});
      //this.showprice();
    }
    this.clearValidationErr(propName);

  };

    openDetail(id){
                window.location='/leads/leadDetail/'+id;
    } 

  handleRejectSubmit = (e) => {
    e.preventDefault();

    if (this.state.reject_reason != "") {
      let userinfo = JSON.stringify({
        set_id: this.state.set_id,
        vendor_id: this.state.vendor_id,
        login_id: this.state.login_id,
        category_id: this.state.category_id,
        email_id: this.state.email_id,
        reject_reason: this.state.reject_reason,
      });

      rejectVendorInfo(userinfo).then((response) => {
        let toastr = "";
        if (response.status == 1) {
          
          NotificationManager.success('Success');
          
          setTimeout(function () {
            window.location.replace("/users/partners");
          }, 1000);
        } else {
          
          NotificationManager.error(response.errors[0].msg);
          
        }
      });
    } else {
      if (this.state.reject_reason == "") {
        this.showValidationErr("reject_reason", "Enter Reason for Reject");
      }
    }
  };


  handleChangeRadio = (e) => {
    const propsName = e.target.name;
    const propsValue = e.target.value;
    this.setState({ [propsName]: propsValue });
  };
  

  gallery_image() {
    let photos =
      this.state.photos_arr !== undefined ? this.state.photos_arr : [];
    let rows = "";
    if (photos.length > 0) {
      rows = photos.map((photos, index) => {
        if (photos.name)
          return (
            <div class="col-md-4 float-left mt-4 p-0">
              <img
                src={this.state.url + photos.name}
                alt="Img"
                class="img-thumbnail"
              />
            </div>
          );
      });
    } else {
      rows = "";
    }
    return rows;
  }


  copyit =(e) => {

      navigator.clipboard.writeText(this.state.short_url);
      alert("url is copied into your clipboard");
  }

  handlePaymentLink =(e) => {

   

   this.setState({loading:false});  
    
   window.$("#payment-modal").modal("show");

   //payment-modal

   /*

   let req = JSON.stringify({
      amount: "1500",
      order_id: 1250
    });

    getPayLink(req).then((res) => {

      console.log(res);
      
    });

    */

    console.log("loading..",this.state.loading);


  }

  customeChange = (e) => {
    let THIS = this;
    let value = e.target.value;
    var i = this.state.plan_id;

    const propsName = e.target.name;
    let upgradeList = this.state.upgradeList;
    if (propsName == 'is_check') {
      value = (upgradeList[i].is_check == false || upgradeList[i].is_check == 'false') ? true : false;

    }
    this.setState({
      checking: true
    })
    upgradeList[i][propsName] = value;
    if (upgradeList[i].nplan_id && upgradeList[i].period == undefined)
      upgradeList[i]['period'] = 365;

    this.setPrice(upgradeList[i].nplan_id, upgradeList[i].period, upgradeList, i);


    let fdata = upgradeList.filter((item) => (item.is_check === true && item.nplanid != 0 && parseInt(item.period) > 0));
    if (fdata.length === 0)
      this.setState({
        basesubtotal: 0, subtotal: 0, discount_per: 0, discount_amount: 0,
        sgst_amount: 0, cgst_amount: 0, totalpayable: 0, totalselected: 0
      });
    setTimeout(function () {
      THIS.setState({
        checking: false
      })
    }, 500)
  }


  set(){
     
    let ins = JSON.stringify({
      vendor_id: this.state.vendor_id,
      discount: this.state.discount
    });
    creatediscount(ins).then((res) => {
      if (res.status == 1) {
        let toastr = '';

        NotificationManager.success('Successfully created');
    
        window.$("#discount-modal").modal("hide");
        this.el.destroy();
        this.getList();

      } else {

        NotificationManager.error('Cant be applied');

        window.$("#discount-modal").modal("hide");
         
      }
    });

  }


  generatePayLink =(e) => {

    var formatamount_1  = Number(this.state.total).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    var formatamount_2 = formatamount_1.replace(",","");
    var formatamount = formatamount_2.replace(".","");
    var amount = formatamount_1;
    var rzamount = formatamount;
    var name = this.state.organisation_name;
    var email_id = this.state.email_id;
    var contact = this.state.phone_number;
    var description = 'Plan Upgrade - Partner Program';
    var plan_name  =this.state.plan_name;
    var period  =this.state.period;
    var vendor_id  =this.state.vendor_id;
    var plan_id  =this.state.plan_id;
    var generated_by  =this.state.generated_by;
    var discount_amount =  this.state.discount_amount;
    var discount_per = this.state.discount_per;

    var optbannerprice = this.state.optbannerprice;
    var optbanners = this.state.optbanners;
    var optbannerperiod = this.state.optbannerperiod;

    var order_id = Date.now();

    let req = JSON.stringify({
      amount: amount,
      rzamount: rzamount,
      name:name,
      email:email_id,
      contact:contact,
      description:description,
      period:period,
      plan_name:plan_name,
      vendor_id:vendor_id,
      plan_id:plan_id,
      generated_by:generated_by,
      discount_amount:discount_amount,
      discount_per:discount_per,
      order_id:order_id
    });

    this.setState({generated:false, loading:true});  

    getPayLink(req).then((res) => {

      
      if(res.status==1){

          let data = res.result;

          let req = JSON.stringify({
                id : data.id,
                short_url : data.short_url,
                vendor_id : this.state.vendor_id,
                plan_id : this.state.plan_id,
                plan_name : this.state.plan_name,
                email : this.state.email_id,
                amount : data.amount,
                period:this.state.period,
                discount_amount : this.state.discount_amount,
                discount_per : this.state.discount_per,
                order_id : order_id,
                generated_by : this.state.generated_by,
                customer_name: this.state.organisation_name,
                customer_email : data.customer.email,
                optbannerprice:this.state.optbannerprice,
                optbanners:this.state.optbanners,
                optbannerperiod:this.state.optbannerperiod
          });

          savePayLink(req).then((payres) => {

              console.log(payres);

              let data = payres;

              this.setState({
              generated:true,
              loading:false,
              short_url : data.short_url,
              email_id:data.customer_email,
              name:data.customer_name
              });


          });

 

      }
       
      
    });
  }

  sendMail_PaymentLink =(e) => {

    let req = JSON.stringify({
      to: this.state.email_id,
      url:this.state.short_url,
      customer_name:this.state.name,
      vendor_id:this.state.vendor_id
    });


    sendMailPayLink(req).then((res) => {

      
      if(res.status==1){

        NotificationManager.success('Mail has been sent');

      }
       
      
    });


  }



  handleSubmitCurated = (e) => {
    e.preventDefault();
    let userinfo = JSON.stringify({
      vendor_id: this.state.vendor_id,
      login_id: this.state.login_id,
      set_id: this.state.set_id,
      category_id: this.state.category_id,
      email_id: this.state.email_id,
    });
    approveVendorInfoCurated(userinfo).then((response) => {
      let toastr = "";
      if (response.status == 1) {
        NotificationManager.success('Partner Info Approved');
      } else {
        NotificationManager.error('There is an issue');
      }
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let userinfo = JSON.stringify({
      vendor_id: this.state.vendor_id,
      login_id: this.state.login_id,
      set_id: this.state.set_id,
      category_id: this.state.category_id,
      email_id: this.state.email_id,
    });
    approveVendorInfo(userinfo).then((response) => {
      let toastr = "";
      if (response.status == 1) {

        NotificationManager.success('Partner Info Approved');
        
         
      } else {

        NotificationManager.error('There is an issue');

        
      }
    });
  };

  handleSendResponse = (type) => {
    let userinfo = JSON.stringify({
      vendor_id: this.state.vendor_id,
      set_id: this.state.set_id,
      login_id: this.state.login_id,
      category_id: this.state.category_id,
      email_id: this.state.email_id,
      parnter_name: this.state.partner_name,
      type: type,
    });
    indResponse(userinfo).then((response) => {
      let toastr = "";
      if (response.status == 1) {

        NotificationManager.success('Partner Response Send Success');
       
        // this.props.history.push("/vendorlist");
      } else {
        NotificationManager.error('There is an issue');
      }
    });
  };

  render() {
    const { data, keyinfo, leads} = this.state;
    data.access = data.access ? data.access : [];
    let reasonErr = null;
    for (let err of this.state.errors) {
      if (err.elm === "reject_reason") {
        reasonErr = err.msg;
      }
    }

        return (
            <React.Fragment>


                  <AdminLayout>

                  <div class="row">
                    <div class="col-md-12">

                        <div className="content-top col-md-12 col-xs-12">
                        <h3>Partner Info</h3>
                        </div>
            
                    <div className="col-md-12 col-xs-12">
                 
                  <div className="partnerinfoclass">
                    <div id="company-info" className="">
                      <div className="box-shadow-custom">
                        <div className="row">
                          <div className="form-group col-md-4">
                            <label>Partner Type</label>
                            <p>{data.partner_type}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Payment Type</label>
                            <p>{data.user_paytype}</p>
                          </div>

                          <div className="form-group col-md-4">
                            <label>Name</label>
                            <p>{data.partner_name}</p>
                          </div>
                          {data.user_type == "1" && (
                            <React.Fragment>
                              <div className="form-group col-md-4">
                                <label>Name of the Institution</label>
                                <p>{data.organisation_name}</p>
                              </div>
                              <div className="form-group col-md-4">
                                <label>Business Regn Number</label>
                                <p>{data.registration_no}</p>
                              </div>
                            </React.Fragment>
                          )}

                          <div className="form-group col-md-4">
                            <label>Address</label>
                            <p>{data.address}</p>
                          </div>

                          <div className="form-group col-md-4">
                            <label>City</label>
                            <p>{data.location}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>State</label>
                            <p>{data.state}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Pincode</label>
                            <p>{data.pin_code}</p>
                          </div>
                          {data.user_type == "1" && (
                            <React.Fragment>
                              <div className="form-group col-md-4">
                                <label>Institution Contact Number</label>
                                <p>{data.institution_contact_number}</p>
                              </div>

                              <div className="form-group col-md-4">
                                <label>Institution Email Address</label>
                                <p>{data.institution_email_address}</p>
                              </div>
                            </React.Fragment>
                          )}

                          <div className="form-group col-md-4">
                            <label>Email Id</label>
                            <p>{data.email_id}</p>
                          </div>

                          <div className="form-group col-md-4">
                            <label>Phone Number</label>
                            <p>{data.phone_number}</p>
                          </div>

                          <div className="form-group col-md-4">
                            <label>Category</label>
                            <p>{data.category_name}</p>
                          </div>
                          {data.user_type == "2" && (
                            <React.Fragment>
                              <div className="form-group col-md-4">
                                <label>Identity Proof</label>
                                <p>{this.state.id_proof}</p>
                              </div>
                              <div className="form-group col-md-4">
                                <label>ID Number</label>
                                <p>{this.state.id_proof_no}</p>
                              </div>
                              <div className="form-group col-md-4">
                                <label>Highest Qualification</label>
                                <p>{this.state.qualification}</p>
                              </div>
                              <div className="form-group col-md-4">
                                <label>Comments</label>
                                <p>{this.state.othercomments}</p>
                              </div>
                            </React.Fragment>
                          )}
                        </div>
                      </div>
                      <div className="box-shadow-custom pad-reduce">
                        <div className="row">
                          <div className="col-md-12 col-xs-12">
                            <span className="form-legend">
                              Payment Information
                            </span>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Name of the Package</label>
                            <p>{data.plan_name}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Package Value</label>
                            <p>{data.pack_value}</p>
                          </div>
                          {this.state.discount != 0 && (
                            <div className="form-group col-md-4">
                              <label>
                                Package Discount
                                {data.discount != 0 && (
                                  <React.Fragment>
                                    ({data.discount}%)
                                  </React.Fragment>
                                )}
                              </label>
                              <p>{data.discount_amount}</p>
                            </div>
                          )}
                          <div className="form-group col-md-4">
                            <label>Amount Paid</label>
                            <p>{data.amount}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Words Limit</label>
                            <p>{data.word_count}</p>
                          </div>

                          <div className="form-group col-md-4">
                            <label>Upload image limit</label>
                            <p>{data.image_count}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Start Date</label>
                            <p>{data.start_date}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>End Date</label>
                            <p>{data.end_date}</p>
                          </div>
                        </div>
                      </div>

                      <div className="box-shadow-custom pad-reduce">
                        <div className="row">
                          <div className="col-md-12 col-xs-12">
                            <span className="form-legend">
                              Complete Registration Information
                            </span>
                          </div>
                          {data.registration_no && (
                            <div className="form-group col-md-4">
                              <label>Registration No</label>
                              <p>{data.registration_no}</p>
                            </div>
                          )}
                          {data.owner_name && (
                            <div className="form-group col-md-4">
                              <label>Owner Name</label>
                              <p>{data.owner_name}</p>
                            </div>
                          )}
                          <div className="form-group col-md-4">
                            <label>Organization Name</label>
                            <p>{data.organisation_name}</p>
                          </div>
                        </div>
                      </div>
                      {data.access.includes('1') && (
                        <div class="box-shadow-custom pad-reduce">
                          <div className="row">
                            <div className="col-md-12 col-xs-12">
                              <span className="form-legend">
                                {data.category_name} Information
                              </span>
                            </div>
                          </div>
                          <div class="row">
                            <div className="form-group col-md-4">
                              <label>Sub Categories</label>
                              <p>{keyinfo.sub_categories ? keyinfo.sub_categories : ''}</p>
                            </div>

                            <div className="form-group col-md-4">
                              <label className="text-capitalize">
                                Board of Education
                              </label>
                              <p>{keyinfo.curriculum}</p>
                            </div>
                            <div className="form-group col-md-4">
                              <label className="text-capitalize">Campus Type</label>
                              <p>{keyinfo.types_school}</p>
                            </div>
                          </div>
                        </div>
                      )}

                      {data.access.includes("2") && (
                        <React.Fragment>
                          <div class="box-shadow-custom pad-reduce">
                            <div className="row">
                              <div className="col-md-12 col-xs-12">
                                <span className="form-legend">
                                  {data.category_name} Information
                                </span>
                              </div>
                              <div className="form-group col-md-4">
                                <label>Sub Categories</label>
                                <p>{keyinfo.sub_categories ? keyinfo.sub_categories : ''}</p>
                              </div>
                           
                            </div>
                          </div>
                        </React.Fragment>
                      )}

                      {data.access.includes("3") && (
                        <React.Fragment>
                          <div class="box-shadow-custom pad-reduce">
                            <div className="row">
                              <div className="col-md-12 col-xs-12">
                                <span className="form-legend">
                                  {data.category_name} Information
                                </span>
                              </div>
                            </div>
                            <div class="row">
                              <div className="form-group col-md-4">
                                <label>Sub Categories</label>
                                <p>{keyinfo.sub_categories ? keyinfo.sub_categories : ''}</p>
                              </div>
                              <div className="form-group col-md-4">
                                <label className="text-capitalize">
                                  Catering To Age Group
                                </label>
                                <p>{keyinfo.play_age}</p>
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      )}

                      {data.access.includes("4") &&
                        (
                          <React.Fragment>
                            <div class="box-shadow-custom pad-reduce">
                              <div className="row">
                                <div className="col-md-12 col-xs-12">
                                  <span className="form-legend">
                                    {data.category_name} Information
                                  </span>
                                </div>
                              </div>
                              <div class="row">
                                <div className="form-group col-md-4">
                                  <label>After School type</label>
                                  <p>{keyinfo.fcategory}</p>
                                </div>

                                <div className="form-group col-md-4">
                                  <label>{keyinfo.fcategory} type</label>
                                  <p>{keyinfo.sub_categories ? keyinfo.sub_categories : ''}</p>
                                </div>
                                <div className="form-group col-md-4">
                                  <label>{keyinfo.fcategory} types</label>
                                  <p>{keyinfo.sub_categories ? keyinfo.sub_categories : ''}</p>
                                </div>
                              </div>
                            </div>
                          </React.Fragment>
                        )
                      }

                      {data.access.includes("6") && keyinfo.length>0 && (
                        <React.Fragment>
                          <div class="box-shadow-custom pad-reduce">
                            <div className="row">
                              <div className="col-md-12 col-xs-12">
                                <span className="form-legend">
                                  {data.category_name} Information
                                </span>
                              </div>
                            </div>
                            <div class="row">
                              <div className="form-group col-md-4">
                                <label>Incharge Name </label>
                                <p>{keyinfo.incharge_name}</p>
                              </div>

                              <div className="form-group col-md-4">
                                <label>Tutions type</label>
                                <p>{keyinfo.sub_categories ? keyinfo.sub_categories : ''}</p>
                              </div>

                              <div className="form-group col-md-4" >
                                <label>
                                  Languages<span className="astrick">*</span>
                                </label>
                                <p>{keyinfo.sub_types}</p>
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      )}

                      {
                        data.access.includes("7") && (
                          <React.Fragment>
                            <div class="box-shadow-custom pad-reduce">
                              <div className="row">
                                <div className="col-md-12 col-xs-12">
                                  <span className="form-legend">
                                    {data.category_name} Information
                                  </span>
                                </div>
                              </div>
                              <div class="row">
                                <div className="form-group col-md-4">
                                  <label>
                                    Events type
                                  </label>
                                  <p>{keyinfo.sub_categories ? keyinfo.sub_categories : ''}</p>
                                </div>
                              </div>
                            </div>
                          </React.Fragment>
                        )
                      }

                      {data.access.includes("8") && (
                        <React.Fragment>
                          <div class="box-shadow-custom pad-reduce">
                            <div className="row">
                              <div className="col-md-12 col-xs-12">
                                <span className="form-legend">
                                  {data.category_name} Information
                                </span>
                              </div>
                            </div>
                            <div class="row">
                              <div className="form-group col-md-4">
                                <label>Child Age Group </label>
                                <p>{keyinfo.sub_categories ? keyinfo.sub_categories : ''}</p>
                              </div>

                              <div className="form-group col-md-4">
                                <label className="text-capitalize">Type</label>
                                <p>{keyinfo.sub_type}</p>
                              </div>

                              <div className="form-group col-md-4">
                                <label>BeWise Curated?</label>
                                <p>{keyinfo.iscurated==1 ? 'Yes' : 'No'}</p>
                              </div>
                              <div className="form-group col-md-4">
                                <label>Approved BeWise Curated?</label>
                                <p>{keyinfo.iscurated_approved==1 ? 'Yes' : 'No'}</p>
                              </div>

                            </div>
                          </div>
                        </React.Fragment>
                      )
                      }

                      {
                        data.access.includes("121") && (
                          <React.Fragment>
                            <div class="box-shadow-custom pad-reduce">
                              <div className="row">
                                <div className="col-md-12 col-xs-12">
                                  <span className="form-legend">
                                    {data.category_name} Information
                                  </span>
                                </div>
                              </div>
                              <div class="row">
                                <div className="form-group col-md-4">
                                  <label>
                                    Community type
                                    <span className="astrick">*</span>
                                  </label>
                                  <p>{keyinfo.sub_categories ? keyinfo.sub_categories : ''}</p>
                                </div>

                                <React.Fragment>
                                  <div class="form-group col-md-4" >
                                    <label>Designation</label>
                                    <p>{keyinfo.designation}</p>
                                  </div>

                                  <div class="form-group col-md-4">
                                    <label>Service</label>
                                    <p>{keyinfo.service}</p>
                                  </div>
                                </React.Fragment>
                              </div>
                            </div>
                          </React.Fragment>
                        )
                      }

                      <div class="box-shadow-custom pad-reduce">
                        <div className="row">
                          <div className="col-md-12 col-xs-12">
                            <span className="form-legend">
                              Address Information
                            </span>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Email Id</label>
                            <p>{data.email_id}</p>
                          </div>

                          <div className="form-group col-md-4">
                            <label>Phone Number</label>
                            <p>{data.phone_number}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Landline Number</label>
                            <p>{data.landline_number}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Address</label>
                            <p>{data.address}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Google Address</label>
                            <p>{data.google_location}</p>
                          </div>

                          <div className="form-group col-md-4">
                            <label>City</label>
                            <p>{data.location}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>State</label>
                            <p>{data.state}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Pincode</label>
                            <p>{data.pin_code}</p>
                          </div>

                        </div>
                      </div>


                      <div class="box-shadow-custom">
                        <div class="row">
                          <div className="col-md-12 col-xs-12">
                            <span className="form-legend">
                              Admission/Fee
                            </span>
                          </div>
                          {
                            (data.access.includes('1') || data.access.includes('2'))
                            && (
                              <React.Fragment>
                                <div class="form-group col-md-4">
                                  <label>Admission Link</label>
                                  <p>{data.admission_link}</p>
                                </div>
                                <div class="form-group col-md-4">
                                  <label>Application Fees (INR)</label>
                                  <p>{data.application_fees}</p>
                                </div>
                                <div class="form-group col-md-4">
                                  <label> Required Documents</label>
                                  <p>{data.required_documents}</p>
                                </div>
                                <div class="form-group col-md-4">
                                  <label>Other Fees (INR) </label>
                                  <p>{this.state.other_fees}</p>
                                </div>
                                <div class="form-group col-md-4">
                                  <label>Admission Process</label>
                                  <p>{data.admission_process}</p>
                                </div>
                                <div class="form-group col-md-4">
                                  <label>Is Refundable (Admission Fees)</label>
                                  <p>{data.is_refund}</p>
                                </div>
                              </React.Fragment>
                            )}
                          {(data.access.includes('1') || data.access.includes('2'))
                            && (
                              <React.Fragment>
                                <div class="form-group col-md-4">
                                  <label>Average Annual Fees (INR) </label>
                                  <p>{data.average_fees}</p>
                                </div>
                                <div class="form-group col-md-4">
                                  <label>Recurring Fees (INR) </label>
                                  <p>{this.state.admission_fees}</p>
                                </div>
                              </React.Fragment>
                            )}
                          {(data.access.includes('4') || data.access.includes('6'))
                            && (
                              <React.Fragment>
                                <div class="form-group col-md-4">
                                  <label>Average Fees (INR) </label>
                                  <p>{data.average_fees}</p>
                                </div>
                                <div class="form-group col-md-4">
                                  <label>Class Fees (INR) </label>
                                  <div class="row">
                                    <div class="form-group col-md-6">
                                      <p>{data.class_fee}</p>
                                    </div>
                                    <div class="form-group col-md-6">
                                      <p>{(data.class_fee_type == '' || data.class_fee_type == '0') &&
                                        ('NA')
                                      }
                                        {(data.class_fee_type == '2') &&
                                          ('Per Participant')
                                        }
                                        {(data.has_trail == '1') &&
                                          (`Per Class`)
                                        }</p>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group col-md-4">
                                  <label>Recurring Fees (INR) </label>
                                  <p>{this.state.admission_fees}</p>
                                </div>
                              </React.Fragment>
                            )}
                          {(data.access.includes('3') || data.access.includes('121'))
                            && (
                              <React.Fragment>
                                <div class="form-group col-md-4">
                                  <label>Entry Fees (INR)</label>
                                  <p>{data.entry_fees}</p>
                                </div>
                              </React.Fragment>
                            )}
                          {(data.access.includes('8') || data.access.includes('7'))
                            && (
                              <React.Fragment>
                                <div class="form-group col-md-4">
                                  <label>Entry Fees (INR)</label>
                                  <p>{data.event_fee}</p>
                                </div>
                              </React.Fragment>
                            )}
                        </div>
                      </div>


                      <div class="box-shadow-custom">
                        <div class="row">
                          <div className="col-md-12 col-xs-12">
                            <span className="form-legend">Key Information</span>
                          </div>
                          {data.access.includes('1') && (
                            <React.Fragment>
                              <div class="form-group col-md-4">
                                <label>School type </label>
                                <p>{keyinfo.school_type}</p>
                              </div>
                              <div class="form-group col-md-4">
                                <label>Classification </label>
                                <p>{keyinfo.classification}</p>
                              </div>
                              <div className="form-group col-md-4">
                                <label>Grade</label>
                                <p>{(keyinfo.grades && keyinfo.grades.includes('NA') ? 'NA' : keyinfo.grades)}</p>
                              </div>
                              <div className="form-group col-md-4">
                                <label>Teacher Student Ratio</label>
                                <p>{keyinfo.std_ratio}</p>
                              </div>

                            </React.Fragment>
                          )}
                          {(data.access.includes('6'))
                            && (
                              <React.Fragment>
                                <div className="form-group col-md-4">
                                  <label>Person Incharge </label>
                                  <p>{keyinfo.incharge_name}</p>
                                </div>
                                <div className="form-group col-md-4">
                                  <label>Board of Education</label>
                                  <p>{keyinfo.curriculum}</p>
                                </div>
                                <div className="form-group col-md-4">
                                  <label>Teaching For Grades </label>
                                  <p>{keyinfo.class_range}</p>
                                </div>
                              </React.Fragment>
                            )}
                          {(data.access.includes('1') || data.access.includes('6'))
                            && (
                              <React.Fragment>
                                <div className="form-group col-md-4">
                                  <label>Instruction Languages</label>
                                  <p>{keyinfo.inst_lang}</p>
                                </div>
                              </React.Fragment>
                            )}
                          {(data.access.includes('7'))
                            &&
                            (
                              <React.Fragment>
                                <div className="form-group col-md-4">
                                  <label>Hall Capacity</label>
                                  <p>{keyinfo.hall_capcity}</p>
                                </div>
                                <div className="form-group col-md-4">
                                  <label>Dinning Hall Capacity</label>
                                  <p>{keyinfo.dinning_capacity}</p>
                                </div>
                                <div className="form-group col-md-4">
                                  <label>Car Parking</label>
                                  <p>{keyinfo.car_parking_slot}</p>
                                </div>
                                <div className="form-group col-md-4">
                                  <label>Two Wheeler Parking</label>
                                  <p>{keyinfo.two_parking_slot}</p>
                                </div>
                                <div className="form-group col-md-4">
                                  <label>Operating Hours</label>
                                  <p>{keyinfo.timing}</p>
                                </div>
                                <div className="form-group col-md-4">
                                  <label>Type of Food Served </label>
                                  <p>{keyinfo.food}</p>
                                </div>
                              </React.Fragment>
                            )
                          }
                          {(data.access.includes('121') || data.access.includes('7'))
                            && (
                              <React.Fragment>
                                <div className="form-group col-md-4">
                                  <label>Mode of Payment </label>
                                  <p>{keyinfo.payment}</p>
                                </div>
                              </React.Fragment>
                            )}
                          {(data.access.includes('121'))
                            && (
                              <React.Fragment>
                                <div className="form-group col-md-4">
                                  <label>Designation</label>
                                  <p>{keyinfo.designation}</p>
                                </div>

                              </React.Fragment>
                            )}
                          {(data.access.includes('8') || data.access.includes('7'))
                            && (
                              <React.Fragment>
                                <div className="form-group col-md-4">
                                  <label>Contact Person </label>
                                  <p>{keyinfo.contact_person}</p>
                                </div>
                              </React.Fragment>
                            )}
                          {(data.access.includes('8'))
                            && (
                              <React.Fragment>
                                <div className="form-group col-md-4">
                                  <label>Teacher Student Ratio </label>
                                  <p>{keyinfo.learn_opt}</p>
                                </div>

                                <div className="form-group col-md-4">
                                  <label>When (Date)</label>
                                  <p>{keyinfo.when_event}</p>
                                </div>
                                <div className="form-group col-md-4">
                                  <label>Where</label>
                                  <p>{keyinfo.where_event}</p>
                                </div>
                                <div className="form-group col-md-4">
                                  <label>Registration Info (Email ID)</label>
                                  <p>{keyinfo.register_info}</p>
                                </div>
                              </React.Fragment>
                            )}
                          {
                            (data.access.includes('1') || data.access.includes('2') || data.access.includes('3'))
                            && (
                              <React.Fragment>
                                <div className="form-group col-md-4">
                                  <label>Amenities </label>
                                  <p>{data.facilities}</p>
                                </div>
                              </React.Fragment>
                            )}

                          {
                            (data.access.includes('1') || data.access.includes('2') ||
                              data.access.includes('3') || data.access.includes('4') ||
                              data.access.includes('6'))
                            && (
                              <React.Fragment>
                                <div className="form-group col-md-4">
                                  <label>Timing</label>
                                  <p>{(keyinfo.time && keyinfo.time.includes('NA') ? 'NA' : keyinfo.time)}</p>
                                </div>
                                <div className="form-group col-md-4">
                                  <label>No Of Teachers</label>
                                  <p>{keyinfo.teacher_count}</p>
                                </div>
                              </React.Fragment>
                            )}
                          {
                            (data.access.includes('1') || data.access.includes('2') ||
                              data.access.includes('3') || data.access.includes('4') ||
                              data.access.includes('6') || data.access.includes('121') || data.access.includes('7'))
                            && (
                              <React.Fragment>
                                <div className="form-group col-md-4">
                                  <label>Establishment Year</label>
                                  <p>{keyinfo.est_year}</p>
                                </div>
                              </React.Fragment>
                            )}
                          {
                            (data.access.includes('1') || data.access.includes('2') || data.access.includes('4'))
                            && (
                              <React.Fragment>
                                <div className="form-group col-md-4">
                                  <label>Min Age of Admission </label>
                                  <p>{keyinfo.min_age}</p>
                                </div>
                              </React.Fragment>
                            )}
                          {(data.access.includes('4') || data.access.includes('6'))
                            &&
                            (
                              <React.Fragment>
                                <div className="form-group col-md-4">
                                  <label>Class Frequency</label>
                                  <p>{keyinfo.freq_name}</p>
                                </div>
                              </React.Fragment>
                            )
                          }

                          {
                            (data.access.includes('4') || data.access.includes('6')
                              || data.access.includes('8'))
                            &&
                            (
                              <React.Fragment>
                                <div className="form-group col-md-4">
                                  <label>Learning Option </label>
                                  <p>{keyinfo.learn_opt}</p>
                                </div>
                                <div className="form-group col-md-4">
                                  <label>Learning Location</label>
                                  <p>{keyinfo.learn_loc}</p>
                                </div>
                              </React.Fragment>
                            )
                          }
                          <div className="form-group col-md-4">
                            <label>Website</label>
                            <p>{data.website}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Website Search Keyword</label>
                            <p>{data.key_words}</p>
                          </div>
                        </div>
                        <div className='row'>
                          <div className="form-group col-md-12">
                            <label>About</label>
                            <div dangerouslySetInnerHTML={{__html:data.about}}></div>
                          </div>
                        </div>
                      </div>
                      {(data.idproof_att || data.qualification_att || data.user_image_att) && (
                        <div class="box-shadow-custom">
                          <div class="row">
                            <div className="col-md-12 col-xs-12">
                              <span className="form-legend">Documents uploaded</span>
                            </div>
                            {data.idproof_att &&
                              <div className="form-group col-md-4">
                                <label>ID Proof</label><br />
                                <a href={data.url + data.idproof_att} target='_blank'>View</a>
                              </div>
                            }
                            {data.qualification_att &&
                              <div className="form-group col-md-4">
                                <label>Qualification Certificate</label><br />
                                <a href={data.url + data.idproof_att} target='_blank'>View</a>
                              </div>
                            }
                            {data.user_image_att &&
                              <div className="form-group col-md-4">
                                <label>User Image</label><br />
                                <a href={data.url + data.user_image_att} target='_blank'>View</a>
                              </div>
                            }
                          </div>
                        </div>
                      )}

                      <div className="box-shadow-custom">
                        <div className="row">
                          <div className="col-md-12 col-xs-12">
                            <span className="form-legend">Images</span>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Banner Images</label>
                            {this.state.images && (
                              <img
                                src={this.state.url + this.state.images}
                                alt="Img"
                                class="img-thumbnail"
                              />
                            )}
                            {!this.state.images && <div>No images</div> }
                          </div>

                          <div class="col-md-12 float-left mt-4 p-0">
                            <label>Gallery Images</label>
                          </div>

                          {this.gallery_image()}
                        </div>
                      </div>


                       <div class="box-shadow-custom">
                        <div class="row">
                          <div className="col-md-12 col-xs-12">
                            <span className="form-legend">
                              Leads ({leads.length} Total Leads Received)
                            </span>
                          </div>

                          <div className="col-md-12 col-xs-12">
                          {leads.length>0 &&
                          <table class="table table-bordered table-sm">
                              <thead class="thead-dark">
                                <tr>
                                    <th>S.No</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Date</th>
                                    <th>Vertical</th>
                                    <th>Action</th>
                                 </tr>
                                </thead>
                                <tbody>
                                     {leads.map((lead, i) => {     
                                              
                                               return <tr>
                                                  <td>
                                                    {i+1}
                                                  </td>
                                                  
                                                 
                                                  <td>{lead.firstname}</td>
                                                  <td>{lead.lastname}</td>
                                                  <td>{lead.createdAt}</td>
                                                  <td>{lead.vertical}</td>
                                                  <td>
                                                    <button class="btn btn-primary btn-sm" onClick={()=>this.openDetail(lead.id)}>Detail</button>&nbsp;
                                                                                                       
                                                  </td> 

                                                </tr>

                                              })

                                              }
                                </tbody> 
                            </table>     
                            }
                            {leads.length==0 && <div class="danger">No Leads yet</div>}

                          </div>
                          
                         </div>
                      </div>


                      <div className="box-shadow-custom">
                        <div className="row">
                          <div className="col-md-12 col-xs-12">
                            <span className="form-legend">Approve Status</span>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Approve Status</label>
                            <p className={this.state.apporve_status}>{this.state.reg_process == 3 ? 'Rejected' : this.state.apporve_status}</p>
                          </div>
                          {this.state.reject_reason && (
                            <div className="form-group col-md-4">
                              <label>Reject Reason</label>
                              <p>{this.state.reject_reason}</p>
                            </div>
                          )}
                        </div>
                      </div>
                      {this.state.write_permission && (
                        <React.Fragment>
                        <div className="box-shadow-custom">
                         <div class="row col-md-12">

                          {(this.state.usertype == 1 || (this.state.usertype == 2 )) && (
                            <div className="col-md-12 col-xs-12 btn-bdr">
                              <button
                                id="btnSubmit"
                                // onClick={this.handleRejectSubmit}
                                onClick={() => this.importSchool()}
                                className="btn btn-gray btn-sm reject_btn"
                              >
                                Reject
                              </button>
                              {this.state.apporve_status!='Approved' &&
                              <button
                                id="btnSubmit"
                                style={{ float: "right" }}
                                onClick={this.handleSubmit}
                                className="btn btn-primary btn-sm"
                              >
                                Approve
                              </button>
                              }
                               <button
                                id="btnSubmitDiscount"
                                style={{ float: "right", marginRight:"10px" }}
                                onClick={this.openDiscountBlock}
                                className="btn btn-primary btn-sm"
                              >
                                Set Discount
                              </button>
                               

                              <button
                                id="btnSubmit"
                                style={{ float: "right", marginRight:"10px" }}
                                onClick={this.handlePaymentLink}
                                className="btn btn-primary btn-sm"
                              >
                                Send Payment Link
                              </button>
                               
                              <button
                                id="btnSubmitCurated"
                                style={{ float: "right", marginRight:"10px" }}
                                onClick={this.handleSubmitCurated}
                                className="btn btn-primary btn-sm"
                              >
                                Approve BeWise Curated
                              </button>

                            </div>
                          )}
                          {/* (this.state.usertype == 2 && (this.state.reg_process == 0 || this.state.reg_process == 2)) && (
                            <div className="col-md-12 col-xs-12 btn-bdr">
                              <button
                                id="btnSubmit"
                                onClick={() => this.handleSendResponse(0)}
                                className="btn btn-gray btn-sm reject_btn"
                              >
                                Reject
                              </button>
                              <button
                                id="btnSubmit"
                                style={{ float: "right" }}
                                onClick={() => this.handleSendResponse(1)}
                                className="btn btn-primary btn-sm"
                              >
                                {this.state.reg_process == 2 ? 'Accept and Resend Document upload link ' : ' Accept and Send Document upload link'}

                              </button>
                            </div>
                          ) */}

                        </div> </div>
                        </React.Fragment>
                      )}
                      {this.state.plan_id == 0 && (
                        <div className="box-shadow-custom mar-top">
                          <form onSubmit={this.handleStampForm}>
                            <div className="row">
                              <div className="col-md-12 col-xs-12">
                                <span className="form-legend">Stamp</span>
                              </div>

                              <div className="col-md-4">
                                <button className="btn btn-primary">{this.state.nstamp_id ? 'Assign' : 'Unassign'}</button>
                              </div>
                            </div>
                          </form>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
               


            <div class="modal fade" role="dialog" tabindex="-1" id="import-modal">
                <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title">Reject</h5>
                        </div>
                        <div class="modal-body">
                          <div class="form-group col-md-12 col-xs-12 pad-no">
                            <div class="col-sm-4 col-xs-12">
                              <label for="name">Reject Reason</label>
                            </div>
                            <div class="col-sm-8 col-xs-12">
                              <textarea
                                className="form-control"
                                rows="4"
                                cols="50"
                                name="reject_reason"
                                onChange={this.handleChange}
                              ></textarea>
                              <small className="alert-msg text-danger">
                                {reasonErr ? reasonErr : ""}
                              </small>
                            </div>
                          </div>
                        </div>
                        <div class="modal-footer" style={{ "border-top": "none" }}>
                          <button
                            type="button"
                            class="btn btn-light"
                            data-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            class="btn btn-success"
                            onClick={this.handleRejectSubmit}
                          >
                            Rejected
                          </button>
                        </div>
                      </div>
                </div>
            </div>


<div class="modal fade" role="dialog" tabindex="-1" id="payment-modal">
          <div class="modal-dialog modal-md modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Payment Information</h5>
              </div>
              <div class="modal-body">
                
                <div class="paymentblock">
                     

                      <p>You are generating new razorpay link with customer info and price!</p>           
                  
                      <div>
                            <div>Confirm the payment amount and particulars</div>
                            <br/>

                            <div class="borderedblock">
                            <div class="form-group row">
                              <div class="col-sm-8">Cost of Banners/premium listing/AD support as agreed</div>
                              <div class="col-sm-4">
                                
                                        <div class="form-check-inline">
                                          <label class="form-check-label">
                                            <input type="radio" class="form-check-input" name="optbanners"  value="yes"  onChange={this.handleChange} />&nbsp;Yes&nbsp;
                                          </label>
                                        </div>
                                        <div class="form-check-inline">
                                          <label class="form-check-label">
                                            <input type="radio" class="form-check-input" name="optbanners" value="no"  onChange={this.handleChange}/>&nbsp;No&nbsp;
                                          </label>
                                        </div>

                              </div>
                            </div>
                            {this.state.opener && 
                            <div class="form-group row">
                              <div class="form-group col-md-6">
                                  <label>Enter cost</label>
                                  <input type="text" class="form-control form-input" name="optbannerprice"  onChange={this.updatePrice} />
                              </div>
                               <div class="form-group col-md-6">
                                  <label>Select Period</label>
                                  <select
                                    name="optbannerperiod"
                                    onChange={this.handleChange}
                                    className='form-control selectpicker banner_period' title='Banner Expiration Period'>
                                    <option value='12'>12 Months</option>
                                    <option value='10'>10 Months</option>
                                    <option value='8'>8 Months</option>
                                    <option value='6'>6 Months</option>
                                    <option value='3'>3 Months</option>
                                    <option value='2'>2 Months</option>
                                    <option value='1'>1 Month</option>
                                    </select>
                                  
                              </div>
                            </div>
                            }
                            </div>
                            <br/>

                            <div class="form-row">
                            <div class="form-group col-md-12">
                           <label>Choose the Period</label>
                            <select
                            name="period"
                            onChange={this.handleChange}
                            className='form-control selectpicker plan_period' title='Period'>
                            <option value='365'>12 Months</option>
                            <option value='183'>6 Months</option>
                            </select>
                            
                            </div>
                            </div>
                                                        <br/>

                            <div class="form-row">
                            <div class="form-group col-md-12">
                            <label>Choose the Plan</label>
                              
                             <select title='Select' name='nplan_id' className='form-control' onChange={this.showprice}>
                                <option value="">select</option>
                              {this.state.package_list.map((items, i) => {
                                {
                                  
                                    return (
                                      <option value={i} >
                                        {items.plan_name}
                                      </option>
                                    )
                                  
                                }
                              })
                              }
                              </select>

                            </div>
                            </div>


                          {this.state.showprice &&

                          <div class="form-row col-md-12">
                            <div class="table-responsive">
                          <table class="table table-condensed">
                          <thead>
                            <tr>
                            <td><strong>Item</strong></td>
                            <td class="text-center"><strong>Price</strong></td>
                            <td class="text-center"><strong>Quantity</strong></td>
                            <td class="text-right"><strong>Totals</strong></td>
                            </tr>
                        </thead>
                      <tbody>
                  
                  <tr>
                    <td>{this.state.plan_name}</td>
                    <td class="text-center">&#8377;{Number(this.state.plan_price).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</td>
                    <td class="text-center">1</td>
                    <td class="text-right">&#8377;{Number(this.state.plan_price).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</td>
                  </tr>
                               
                  <tr>
                    <td class="thick-line"></td>
                    <td class="thick-line"></td>
                    <td class="thick-line text-center"><strong>Subtotal</strong></td>
                    <td class="thick-line text-right">&#8377;{Number(this.state.sub_total).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</td>
                  </tr>
                  <tr>
                    <td class="no-line"></td>
                    <td class="no-line"></td>
                    <td class="no-line text-center"><strong>Discount</strong></td>
                    <td class="no-line text-right">&#8377;{Number(this.state.discount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</td>
                  </tr>
                  {this.state.optbanners=='yes' && 
                  <tr>
                    <td class="no-line"></td>
                    <td class="no-line"></td>
                    <td class="no-line text-center"><strong>Cost of Banners/Premium listing and etc</strong></td>
                    <td class="no-line text-right">&#8377;{Number(this.state.optbannerprice).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</td>
                  </tr>
                  }
                  <tr>
                    <td class="no-line"></td>
                    <td class="no-line"></td>
                    <td class="no-line text-center"><strong>Total</strong></td>
                    <td class="no-line text-right">&#8377;{Number(this.state.total).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</td>
                  </tr>
                </tbody>
              </table>
            </div>      


                            </div>

                            }
                           
                            <div class="form-row">
                            <div class="form-group col-md-12">
                             
                            <button id="genpaylink" class="btn btn-primary btn-sm" onClick={this.generatePayLink}>Generate Pay Link</button>
                            </div>
                            </div>

                            {this.state.loading && 
                              <div class="loadinganimation"><img src={loadinggif}/></div>
                            }

                            {!this.state.loading && this.state.generated &&
                            
                            <div class="form-row">
                            <div class="razresult">
                                <input type="hidden" id="short_url" value={this.state.short_url} />
                                <div class="paylinkcss">{this.state.short_url}</div><div class="clickcopy" onClick={this.copyit}><i class="fa fa-clone" aria-hidden="true"></i></div>

                            </div>
                            <div class="mailaction">
                                  <p>You can send payment link to your or given email address below</p>
                                  <div class="form-group">
                                  <label>Email Address:</label>
                                  <input type="text" name="email_id" class="form-control" onChange={this.handleChange} value={this.state.email_id} />
                                  </div>

                                  <div class="form-group">
                                    <button class="btn btn-primary btn-sm" onClick={this.sendMail_PaymentLink} id="clicktosend" >Send</button>
                                  </div>

                            </div>
                            </div>

                            }       
                        </div>

                </div>  
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-light" data-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>

         <div class="modal fade" role="dialog" tabindex="-1" id="discount-modal">
          <div class="modal-dialog modal-md modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Discount Information</h5>
              </div>
              <div class="modal-body">
                
                <div class="">
                {this.state.id ==0 && 
                    <div><b>Not Set Yet</b></div>
                }

                <br/>
                <div>
                    
                        <p>This discount will be applied on upgrading your existing plan in subscription page</p>

                </div>
                <div class="radiobuttons">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="discount" value="5" checked={this.state.discount === "5"}  onChange={this.handleChangeRadio}/>
                  <label class="form-check-label featured_label" for="exampleRadios1">
                    5% 
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="discount"  value="10" checked={this.state.discount === "10"} onChange={this.handleChangeRadio}/>
                  <label class="form-check-label featured_label" for="exampleRadios2">
                    10%
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="discount" value="15" checked={this.state.discount === "15"} onChange={this.handleChangeRadio}/>
                  <label class="form-check-label featured_label" for="exampleRadios2">
                    15%
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="discount"  value="20" checked={this.state.discount === "20"} onChange={this.handleChangeRadio}/>
                  <label class="form-check-label featured_label" for="exampleRadios2">
                    20%
                  </label>
                </div>
                
                         

                </div>
               </div>  
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-light" data-dismiss="modal">Cancel</button>
                { this.state.id ==0 && 
                <button type="button" class="btn btn-success" onClick={() => { this.set() }}>Set</button>
                }
                { this.state.id !=0 && 
                  <button type="button" class="btn btn-success" onClick={() => { this.update() }}>Update</button>
                }
                { this.state.id !=0 && 
                <button type="button" class="btn btn-success" data-dismiss="modal" aria-label="Close" onClick={() => { this.listDelDiscount() }}>Remove</button>
                }
              </div>
            </div>
          </div>
        </div>
                </div>
                    </div>
                    <NotificationContainer/>
                </AdminLayout>
            </React.Fragment>
        )
    }


  handleStampForm = (e) => {
    e.preventDefault();
    let req = JSON.stringify({
      vendor_id: this.state.vendor_id,
      url: 'saveStamp',
      stamp_id: this.state.nstamp_id
    })
    adminUser(req).then((res) => {
      let toastr = '';
      if (res.status === 1) {
        toastr = window.toastr.success;
        toastr('', `Stamp Updated Success`, {
          positionClass: "toast-bottom-right",
          containerId: "toast-bottom-right"
        });
        setTimeout(function () {
          window.location.replace("/vendorlist");
        }, 1000);
      } else {
        toastr = window.toastr.error; //warning
        toastr('Update Failed', toastr, {
          positionClass: "toast-bottom-right",
          containerId: "toast-bottom-right"
        });
      }
    })
  }

}


export default partnerDetail;


// WEBPACK FOOTER //
// ./src/components/bewise/partnerDetail.jsx